import React from 'react'
import thefirsttake from '../image/thefirsttake.jpg'
import { NavLink } from 'react-router-dom'

const Varietydetails9 = () => {
  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden h-screen">
      <div>
      <NavLink to="https://www.youtube.com/watch?v=g8h2KMnRQDo"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 p-5" href="https://www.youtube.com/watch?v=g8h2KMnRQDo">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={thefirsttake} alt="Image Description"/>
      </div>

      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-600 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          The First Take
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mb-5 mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>September 18, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>1
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    <hr class="border-purple-500 mt-5"></hr>

<div>
  <div className='flex justify-center'>
     <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>On September 18, 2023 KST, V will make a guest appearance on 'The First Take,' a YouTube channel dedicated to filming musicians and singers performing in a single take. Showtime: 6am PT/9am ET.  </p>
  </div>
</div>
      </div>
    </div>
  )
}

export default Varietydetails9
